// extracted by mini-css-extract-plugin
module.exports =  {"container":"_93444fe79c--container--C7hn2","background":"_93444fe79c--background--KV7Ke","image":"_93444fe79c--image--xN0Ub","footnote":"_93444fe79c--footnote--TDQy5"};